// DON't CHANGE!
// automated by SVGR script
import * as React from "react";
const IntentsIcon = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  "data-icon": "Intents/outline"
}, props), /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M8 22h8c5 0 7-2 7-7V9c0-5-2-7-7-7H8C3 2 1 4 1 9v6c0 5 2 7 7 7Z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeMiterlimit: 10,
  strokeWidth: 2,
  d: "M22.002 9h-4.65M6.65 9H2"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M9 14.33c0 1.29.99 2.33 2.22 2.33h2.51c1.07 0 1.94-.91 1.94-2.03 0-1.22-.53-1.65-1.32-1.93l-4.03-1.4C9.53 11.02 9 10.59 9 9.37c0-1.12.87-2.03 1.94-2.03h2.51c1.23 0 2.22 1.04 2.22 2.33M12.328 6v12"
}));
export default IntentsIcon;